
import { useState } from 'react';
import Drawer from 'react-modern-drawer';


export default function PerformerDetail(param: any) {

    console.log(param)
    const onCloseDrawer = () => {
        param.PerformerDetailChange();
    }

    let [tabsName, SetTabsName] = useState("details");

    return (
        <>
            <Drawer open={param.PerformerDetailOpen}
                onClose={onCloseDrawer}
                direction='right'
                className='react-drawer  allowHscroll allowVscroll'
                size={800}>

                <div className="box noBorderRadius noBorder ws-7 pull-right landing ">

                    <div className='ws-12 pm'>
                        <h1 className='ws-10 text-bold'>Performer Detail</h1>
                        <a onClick={() => onCloseDrawer()} className="btn-xxs modalClose borderNone bgTransparent pull-right" style={{ position: "inherit" }}>
                            <i className="icon-close3 danger"></i>
                        </a>
                    </div>

                    <div className='ws-12 pm'>
                        <div className='ws-12  '>
                            <ul className="nav nav-tabs nav-justified ws-12">
                                <a className={tabsName == 'details' ? "icon-btn edit active " : "icon-btn edit "} onClick={() => SetTabsName('details')}>Identity details</a>
                                <a className={tabsName == 'linkage' ? "icon-btn edit active " : "icon-btn edit "} onClick={() => SetTabsName('linkage')}>BECS linkage</a>
                                <a className={tabsName == 'history' ? "icon-btn edit active " : "icon-btn edit "} onClick={() => SetTabsName('history')}>Cast history </a>
                                <a className={tabsName == 'aliases' ? "icon-btn edit active " : "icon-btn edit "} onClick={() => SetTabsName('aliases')}>Imported aliases</a>
                                <a className={tabsName == 'Audit' ? "icon-btn edit active " : "icon-btn edit "} onClick={() => SetTabsName('Audit')}>Audit trail</a>
                            </ul>
                        </div>
                    </div>


                    <div className='ws-12 pm'>
                        <button type="button" className=" icon-btn close text-bold pull-right height40 width100" onClick={() => onCloseDrawer()}>Close</button>
                    </div>
                </div>
            </Drawer >
        </>
    );
}